import React from 'react';
import { Link } from 'react-router-dom';
import Card from 'react-bootstrap/Card';
import Table from 'react-bootstrap/Table';
import { formatPhoneNumber, toE164 } from '../../format/PhoneNumber';
import { MatchingInmate } from './MergeAll';

type ContactsTableProps = {
  resolvedInmates: MatchingInmate[];
};

const ContactsTable: React.FC<ContactsTableProps> = ({ resolvedInmates }) => {
  const resolvedContacts = resolvedInmates.flatMap(inmate => inmate.contacts);

  if (resolvedContacts.length === 0) {
    return null;
  }

  return (
    <Card className="mb-3">
      <Card.Header>
        <strong>Contacts to be Merged</strong>
      </Card.Header>
      <Card.Body>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Phone Number</th>
              <th>Name</th>
              <th>Inmate</th>
              <th>Facility</th>
            </tr>
          </thead>
          <tbody>
            {resolvedInmates.flatMap((inmate) =>
              inmate.contacts.map((contact, contactIdx) => {
                const e164Number = toE164(contact.ani);
                return (
                  <tr key={`${inmate.id}-${contact.ani}-${contactIdx}`}>
                    <td>
                      <Link to={`/account/${e164Number}`}>{formatPhoneNumber(contact.ani)}</Link>
                    </td>
                    <td>{contact.name || ''}</td>
                    <td>
                      <Link to={`/inmates/view/${inmate.id}`}>
                        {inmate.firstName} {inmate.lastName}
                      </Link>
                    </td>
                    <td>
                      <Link to={`/facilities/view/${inmate.facility.id}`}>
                        {inmate.facility.name}{inmate.facility.state ? ` (${inmate.facility.state})` : ''}
                      </Link>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
};

export default ContactsTable;
